// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import * as firebase from 'firebase'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import {store} from './store'
import VueAnalytics from 'vue-analytics'
import {MediaQueries} from 'vue-media-queries'
import PrismicVue from 'prismic-vue'

const mediaQueries = new MediaQueries()

Vue.use(mediaQueries);
Vue.use(VueAnalytics, {
  id: 'UA-146926503-1',
  router
})

Vue.use(PrismicVue, {
  endpoint: process.env.prismicBase
});

import Inview from 'vueinview'
Vue.use(Inview);

const opts = { }
Vue.use(Vuetify)

// Globally Imported Components
import Alert from '@/components/Shared/Alert.vue'
import Report from '@/components/Shared/Report.vue'

import Checklist from '@/components/Checklist/Checklist.vue'


import Summary from '@/components/Dashboard/Summary.vue'
import Resources from '@/components/Dashboard/Resources.vue'

import SavedSchoolsMain from '@/components/Dashboard/SavedSchools/SavedSchoolsMain.vue'
import SavedSchool from '@/components/Dashboard/SavedSchools/SavedSchool.vue'
import SavedSchools from '@/components/Dashboard/SavedSchools/SavedSchools.vue'
import SavedSchoolInfo from '@/components/Dashboard/SavedSchools/SavedSchoolInfo.vue'
import RemoveSavedSchools from '@/components/Dashboard/SavedSchools/RemoveSavedSchools.vue'
import Degree from '@/components/Dashboard/SavedSchools/RequirementTracker/Degree.vue'
import GPA from '@/components/Dashboard/SavedSchools/RequirementTracker/GPA.vue'
import Prerequisites from '@/components/Dashboard/SavedSchools/RequirementTracker/Prerequisites.vue'
import HealthcareExperience from '@/components/Dashboard/SavedSchools/RequirementTracker/HealthcareExperience.vue'
import PaShadowing from '@/components/Dashboard/SavedSchools/RequirementTracker/PaShadowing.vue'
import Evaluation from '@/components/Dashboard/SavedSchools/RequirementTracker/Evaluation.vue'
import Gre from '@/components/Dashboard/SavedSchools/RequirementTracker/Gre.vue'
import Casper from '@/components/Dashboard/SavedSchools/RequirementTracker/Casper.vue'
import Pacat from '@/components/Dashboard/SavedSchools/RequirementTracker/Pacat.vue'
import InternationalExams from '@/components/Dashboard/SavedSchools/RequirementTracker/InternationalExams.vue'

import Grades from '@/components/Dashboard/Grades/Grades.vue'
import Colleges from '@/components/Dashboard/Grades/Colleges.vue'
import AddCollegeDialog from '@/components/Dashboard/Grades/Colleges/AddCollegeDialog.vue'
import EditCollegeDialog from '@/components/Dashboard/Grades/Colleges/EditCollegeDialog.vue'
import RemoveCollegeDialog from '@/components/Dashboard/Grades/Colleges/RemoveCollegeDialog.vue'

import AddCourseDialog from '@/components/Dashboard/Grades/Courses/AddCourseDialog.vue'
import EditCourseDialog from '@/components/Dashboard/Grades/Courses/EditCourseDialog.vue'
import RemoveCourseDialog from '@/components/Dashboard/Grades/Courses/RemoveCourseDialog.vue'

import RemoveApCourse from '@/components/Dashboard/Grades/Apcourses/RemoveApCourse.vue'
import RemoveClepCourse from '@/components/Dashboard/Grades/Clep/RemoveClepCourse.vue'

import AddSemesterDialog from '@/components/Dashboard/Grades/Semesters/AddSemesterDialog.vue'
import EditSemesterDialog from '@/components/Dashboard/Grades/Semesters/EditSemesterDialog.vue'
import RemoveSemesterDialog from '@/components/Dashboard/Grades/Semesters/RemoveSemesterDialog.vue'

import ViewGradesDetail from '@/components/Dashboard/Grades/ViewGradesDetail.vue'

// PA Shadowing Components
import PaShadowingHours from '@/components/Dashboard/PaShadowingHours/PaShadowingHours.vue'
import AddPaShadowing from '@/components/Dashboard/PaShadowingHours/AddPaShadowing.vue'
import RemovePaShadowing from '@/components/Dashboard/PaShadowingHours/RemovePaShadowing.vue'
import InfoPaShadowing from '@/components/Dashboard/PaShadowingHours/InfoPaShadowing.vue'
import EditPaShadowing from '@/components/Dashboard/PaShadowingHours/EditPaShadowing.vue'

import LogPaShadowingHours from '@/components/Dashboard/PaShadowingHours/PaShadowingHours/LogPaShadowingHours.vue'
import EditPaShadowingHours from '@/components/Dashboard/PaShadowingHours/PaShadowingHours/EditPaShadowingHours.vue'
import RemovePaShadowingHours from '@/components/Dashboard/PaShadowingHours/PaShadowingHours/RemovePaShadowingHours.vue'
import ViewPaShadowingHours from '@/components/Dashboard/PaShadowingHours/ViewPaShadowingHours.vue'

// Healthcare Experience Hours Components
import HealthcareHoursMain from '@/components/Dashboard/ExperienceHours/HealthcareHoursMain.vue'
import HealthcareHours from '@/components/Dashboard/ExperienceHours/HealthcareHours.vue'
import AddInstituition from '@/components/Dashboard/ExperienceHours/AddInstituition.vue'

import DirectPaidHours from '@/components/Dashboard/ExperienceHours/DirectPaidHours/DirectPaidHours.vue'
import LogDirectPaidHours from '@/components/Dashboard/ExperienceHours/DirectPaidHours/LogDirectPaidHours.vue'
import RemoveDirectPaidHours from '@/components/Dashboard/ExperienceHours/DirectPaidHours/RemoveDirectPaidHours.vue'
import EditDirectPaidHours from '@/components/Dashboard/ExperienceHours/DirectPaidHours/EditDirectPaidHours.vue'
import ViewDirectPaidHours from '@/components/Dashboard/ExperienceHours/DirectPaidHours/ViewDirectPaidHours.vue'

import EditLoggedDirectPaidHours from '@/components/Dashboard/ExperienceHours/DirectPaidHours/EditLoggedHours/EditLoggedDirectPaidHours.vue'
import RemoveLoggedDirectPaidHours from '@/components/Dashboard/ExperienceHours/DirectPaidHours/EditLoggedHours/RemoveLoggedDirectPaidHours.vue'

import DirectHours from '@/components/Dashboard/ExperienceHours/DirectHours/DirectHours.vue'
import LogDirectHours from '@/components/Dashboard/ExperienceHours/DirectHours/LogDirectHours.vue'
import RemoveDirectHours from '@/components/Dashboard/ExperienceHours/DirectHours/RemoveDirectHours.vue'
import EditDirectHours from '@/components/Dashboard/ExperienceHours/DirectHours/EditDirectHours.vue'
import ViewDirectHours from '@/components/Dashboard/ExperienceHours/DirectHours/ViewDirectHours.vue'

import EditLoggedDirectHours from '@/components/Dashboard/ExperienceHours/DirectHours/EditLoggedHours/EditLoggedDirectHours.vue'
import RemoveLoggedDirectHours from '@/components/Dashboard/ExperienceHours/DirectHours/EditLoggedHours/RemoveLoggedDirectHours.vue'

import IndirectHours from '@/components/Dashboard/ExperienceHours/IndirectHours/IndirectHours.vue'
import LogIndirectHours from '@/components/Dashboard/ExperienceHours/IndirectHours/LogIndirectHours.vue'
import RemoveIndirectHours from '@/components/Dashboard/ExperienceHours/IndirectHours/RemoveIndirectHours.vue'
import EditIndirectHours from '@/components/Dashboard/ExperienceHours/IndirectHours/EditIndirectHours.vue'
import ViewIndirectHours from '@/components/Dashboard/ExperienceHours/IndirectHours/ViewIndirectHours.vue'

import EditLoggedIndirectHours from '@/components/Dashboard/ExperienceHours/IndirectHours/EditLoggedHours/EditLoggedIndirectHours.vue'
import RemoveLoggedIndirectHours from '@/components/Dashboard/ExperienceHours/IndirectHours/EditLoggedHours/RemoveLoggedIndirectHours.vue'

import VolunteerHours from '@/components/Dashboard/ExperienceHours/VolunteerHours/VolunteerHours.vue'
import LogVolunteerHours from '@/components/Dashboard/ExperienceHours/VolunteerHours/LogVolunteerHours.vue'
import RemoveVolunteerHours from '@/components/Dashboard/ExperienceHours/VolunteerHours/RemoveVolunteerHours.vue'
import EditVolunteerHours from '@/components/Dashboard/ExperienceHours/VolunteerHours/EditVolunteerHours.vue'
import ViewVolunteerHours from '@/components/Dashboard/ExperienceHours/VolunteerHours/ViewVolunteerHours.vue'

import EditLoggedVolunteerHours from '@/components/Dashboard/ExperienceHours/VolunteerHours/EditLoggedHours/EditLoggedVolunteerHours.vue'
import RemoveLoggedVolunteerHours from '@/components/Dashboard/ExperienceHours/VolunteerHours/EditLoggedHours/RemoveLoggedVolunteerHours.vue'

import CommunityServiceHours from '@/components/Dashboard/ExperienceHours/CommunityServiceHours/CommunityServiceHours.vue'
import RemoveCommunityServiceHours from '@/components/Dashboard/ExperienceHours/CommunityServiceHours/RemoveCommunityServiceHours.vue'
import EditCommunityServiceInfo from '@/components/Dashboard/ExperienceHours/CommunityServiceHours/EditCommunityServiceInfo.vue'
import RemoveLoggedCommunityServiceHours from '@/components/Dashboard/ExperienceHours/CommunityServiceHours/EditLoggedHours/RemoveLoggedCommunityServiceHours.vue'
import EditLoggedCommunityServiceHours from '@/components/Dashboard/ExperienceHours/CommunityServiceHours/EditLoggedHours/EditLoggedCommunityServiceHours.vue'


import AddCertification from '@/components/Dashboard/ExperienceHours/AddCertification.vue'
import Certification from '@/components/Dashboard/ExperienceHours/Certifications/Certification.vue'
import RemoveCertification from '@/components/Dashboard/ExperienceHours/Certifications/RemoveCertification.vue'
import EditCertification from '@/components/Dashboard/ExperienceHours/Certifications/EditCertification.vue'


import ExamsMain from '@/components/Dashboard/Exams/ExamsMain.vue'
import Exams from '@/components/Dashboard/Exams/Exams.vue'
import ExamsList from '@/components/Dashboard/Exams/ExamsList.vue'
import ExamInfo from '@/components/Dashboard/Exams/ExamInfo.vue'
import AddExam from '@/components/Dashboard/Exams/AddExam.vue'
import EditExam from '@/components/Dashboard/Exams/EditExam.vue'
import RemoveExam from '@/components/Dashboard/Exams/RemoveExam.vue'
import AddExamScores from '@/components/Dashboard/Exams/AddExamScores.vue'

import Evaluations from '@/components/Dashboard/Evaluations/Evaluations.vue'
import EvaluationsMain from '@/components/Dashboard/Evaluations/EvaluationsMain.vue'
import WriterList from '@/components/Dashboard/Evaluations/WriterList.vue'
import WriterInfo from '@/components/Dashboard/Evaluations/WriterInfo.vue'
import AddEvaluationWriter from '@/components/Dashboard/Evaluations/AddEvaluationWriter.vue'
import RemoveEvaluationWriter from '@/components/Dashboard/Evaluations/RemoveEvaluationWriter.vue'
import EditEvaluationWriter from '@/components/Dashboard/Evaluations/EditEvaluationWriter.vue'

import PaSchoolsList from '@/components/Schools/PaSchoolsList.vue'
import PaSchools from '@/components/Schools/PaSchools.vue'
import PaSchoolsMain from '@/components/Schools/PaSchoolsMain.vue'
import MissionStatement from '@/components/Schools/SchoolDetail/MissionStatement.vue'
import ProgramInfo from '@/components/Schools/SchoolDetail/ProgramInfo.vue'
import AdmissionRequirements from '@/components/Schools/SchoolDetail/AdmissionRequirements.vue'
import Application from '@/components/Schools/SchoolDetail/Application.vue'
import PrePaClub from '@/components/Schools/SchoolDetail/PrePaClub.vue'
import PrePaTrack from '@/components/Schools/SchoolDetail/PrePaTrack.vue'
import HighSchoolEntry from '@/components/Schools/SchoolDetail/HighSchoolEntry.vue'
import Notes from '@/components/Schools/SchoolDetail/Notes.vue'

import PaSchoolFinder from '@/components/PaSchoolFinder/PaSchoolFinder.vue'
import SchoolMatchResults from '@/components/PaSchoolFinder/SchoolMatchResults.vue'

import VTemplate from '@/components/VTemplate'

import Services from '@/components/Services/Services.vue'

// User components
import Subscriptions from '@/components/User/Subscriptions.vue'
import Profile from '@/components/User/Profile.vue'
import UserProfileQuestions from '@/components/User/UserProfileQuestions'

import Countdown from '@/components/Countdown.vue'


Vue.use(require('vue-moment'));

Vue.config.productionTip = false

// Globally Registered Components
Vue.component('v-template', VTemplate)
Vue.component('Alert', Alert)
Vue.component('Report', Report)

Vue.component('Checklist', Checklist)

Vue.component('Summary', Summary)
Vue.component('Resources', Resources)

Vue.component('SavedSchool', SavedSchool)
Vue.component('SavedSchools', SavedSchools)
Vue.component('SavedSchoolsMain', SavedSchoolsMain)
Vue.component('SavedSchoolInfo', SavedSchoolInfo)
Vue.component('RemoveSavedSchools', RemoveSavedSchools)
Vue.component('Degree', Degree)
Vue.component('GPA', GPA)
Vue.component('Prerequisites', Prerequisites)
Vue.component('HealthcareExperience', HealthcareExperience)
Vue.component('PaShadowing', PaShadowing)
Vue.component('Evaluation', Evaluation)
Vue.component('Gre', Gre)
Vue.component('Casper', Casper)
Vue.component('Pacat', Pacat)
Vue.component('InternationalExams', InternationalExams)

Vue.component('Grades', Grades)
Vue.component('Colleges', Colleges)
Vue.component('AddCollegeDialog', AddCollegeDialog)
Vue.component('EditCollegeDialog', EditCollegeDialog)
Vue.component('RemoveCollegeDialog', RemoveCollegeDialog)

Vue.component('AddSemesterDialog', AddSemesterDialog)
Vue.component('EditSemesterDialog', EditSemesterDialog)
Vue.component('RemoveSemesterDialog', RemoveSemesterDialog)

Vue.component('AddCourseDialog', AddCourseDialog)
Vue.component('EditCourseDialog', EditCourseDialog)
Vue.component('RemoveCourseDialog', RemoveCourseDialog)

Vue.component('RemoveApCourse', RemoveApCourse)
Vue.component('RemoveClepCourse', RemoveClepCourse )

Vue.component('ViewGradesDetail', ViewGradesDetail)

Vue.component('PaShadowingHours', PaShadowingHours)
Vue.component('AddPaShadowing', AddPaShadowing)
Vue.component('RemovePaShadowing', RemovePaShadowing)
Vue.component('InfoPaShadowing', InfoPaShadowing)
Vue.component('EditPaShadowing', EditPaShadowing)

Vue.component('LogPaShadowingHours', LogPaShadowingHours)
Vue.component('EditPaShadowingHours', EditPaShadowingHours)
Vue.component('RemovePaShadowingHours', RemovePaShadowingHours)
Vue.component('ViewPaShadowingHours', ViewPaShadowingHours)


Vue.component('HealthcareHoursMain', HealthcareHoursMain)
Vue.component('HealthcareHours', HealthcareHours)
Vue.component('AddInstituition', AddInstituition)

Vue.component('DirectPaidHours', DirectPaidHours)
Vue.component('LogDirectPaidHours', LogDirectPaidHours)
Vue.component('RemoveDirectPaidHours', RemoveDirectPaidHours)
Vue.component('EditDirectPaidHours', EditDirectPaidHours)
Vue.component('ViewDirectPaidHours', ViewDirectPaidHours)

Vue.component('EditLoggedDirectPaidHours', EditLoggedDirectPaidHours)
Vue.component('RemoveLoggedDirectPaidHours', RemoveLoggedDirectPaidHours)

Vue.component('DirectHours', DirectHours)
Vue.component('LogDirectHours', LogDirectHours)
Vue.component('RemoveDirectHours', RemoveDirectHours)
Vue.component('EditDirectHours', EditDirectHours)
Vue.component('ViewDirectHours', ViewDirectHours)


Vue.component('EditLoggedDirectHours', EditLoggedDirectHours)
Vue.component('RemoveLoggedDirectHours', RemoveLoggedDirectHours)


Vue.component('IndirectHours', IndirectHours)
Vue.component('LogIndirectHours', LogIndirectHours)
Vue.component('RemoveIndirectHours', RemoveIndirectHours)
Vue.component('EditIndirectHours', EditIndirectHours)
Vue.component('ViewIndirectHours', ViewIndirectHours)

Vue.component('EditLoggedIndirectHours', EditLoggedIndirectHours)
Vue.component('RemoveLoggedIndirectHours', RemoveLoggedIndirectHours)

Vue.component('VolunteerHours', VolunteerHours)
Vue.component('LogVolunteerHours', LogVolunteerHours)
Vue.component('RemoveVolunteerHours', RemoveVolunteerHours)
Vue.component('EditVolunteerHours', EditVolunteerHours)
Vue.component('ViewVolunteerHours', ViewVolunteerHours)

Vue.component('EditLoggedVolunteerHours', EditLoggedVolunteerHours)
Vue.component('RemoveLoggedVolunteerHours', RemoveLoggedVolunteerHours)

Vue.component('CommunityServiceHours', CommunityServiceHours)
Vue.component('RemoveCommunityServiceHours', RemoveCommunityServiceHours)
Vue.component('EditCommunityServiceInfo', EditCommunityServiceInfo)
Vue.component('RemoveLoggedCommunityServiceHours', RemoveLoggedCommunityServiceHours)
Vue.component('EditLoggedCommunityServiceHours', EditLoggedCommunityServiceHours)

Vue.component('AddCertification', AddCertification)
Vue.component('Certification', Certification)
Vue.component('RemoveCertification', RemoveCertification)
Vue.component('EditCertification', EditCertification)

Vue.component('ExamsMain', ExamsMain)
Vue.component('Exams', Exams)
Vue.component('ExamInfo', ExamInfo)
Vue.component('ExamsList', ExamsList)
Vue.component('AddExam', AddExam)
Vue.component('AddExamScores', AddExamScores)

Vue.component('EditExam', EditExam)
Vue.component('RemoveExam', RemoveExam)

Vue.component('Evaluations', Evaluations)
Vue.component('EvaluationsMain', EvaluationsMain)
Vue.component('WriterList', WriterList)
Vue.component('WriterInfo', WriterInfo)
Vue.component('AddEvaluationWriter', AddEvaluationWriter)
Vue.component('RemoveEvaluationWriter', RemoveEvaluationWriter)
Vue.component('EditEvaluationWriter', EditEvaluationWriter)

Vue.component('PaSchools', PaSchools)
Vue.component('PaSchoolsMain', PaSchoolsMain)
Vue.component('PaSchoolsList', PaSchoolsList)
Vue.component('MissionStatement', MissionStatement)
Vue.component('ProgramInfo', ProgramInfo)
Vue.component('AdmissionRequirements', AdmissionRequirements)
Vue.component('Application', Application)
Vue.component('PrePaClub', PrePaClub)
Vue.component('PrePaTrack', PrePaTrack)
Vue.component('HighSchoolEntry', HighSchoolEntry)
Vue.component('Notes', Notes)

Vue.component('PaSchoolFinder', PaSchoolFinder)
Vue.component('SchoolMatchResults', SchoolMatchResults)

// User components
Vue.component('Subscriptions', Subscriptions)
Vue.component('Profile', Profile)
Vue.component('UserProfileQuestions', UserProfileQuestions)

Vue.component('Countdown', Countdown)

// Services components

Vue.component('Services', Services)


Vue.filter('two_digits', function (value) {
  if(value.toString().length <= 1)
  {
      return "0" + value.toString();
  }
  return value.toString();
});

Vue.filter('round', function (value) {
  return Math.round(value);
});

Vue.filter('removeTimeFromDate', function (value) {
  if (!value) return value
  try {
    const split = value.split('T')
    return Array.isArray(split) ? split[0] : value
  } catch (error) {
    console.log(error)
    return value
  }
})

const FIREBASE = firebase.initializeApp({
  apiKey: process.env.apiKey,
  authDomain: process.env.authDomain,
  databaseURL: process.env.databaseURL,
  projectId: process.env.projectId,
  storageBucket: process.env.storageBucket,
})

Vue.prototype.$firebase = FIREBASE

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify: new Vuetify(opts),
  router,
  store,
  mediaQueries: mediaQueries,
  components: { App },
  template: '<App/>',
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        this.$store.dispatch('autoSignIn', user)
      }
    })
    this.$store.dispatch('loadSchools')
    this.$store.dispatch('loadCourses')
    this.$store.dispatch('fetchFAQCategories')
  }

}).$mount('#app')






// WEBPACK FOOTER //
// ./src/main.js